/* @jsxImportSource react */

import type { FC } from 'react';

import { ProductCardGridItem } from '@packages/modules/src/ProductCardV2/ProductCardV2.GridItem.client';
import type { DesktopDisplayMode } from '../../types';

export type ProductGridSkeletonProps = {
  /**
   * product card layout. Used to determine number of columns.
   *
   * @default 'cards'
   */
  displayMode: DesktopDisplayMode;
  /**
   * number of skeletons to display
   *
   * @default 72
   */
  count?: number;
};

/**
 * Display skeleton when products are loading instead of product cards
 */
export const ProductListVirtualPageSkeleton: FC<ProductGridSkeletonProps> = ({
  displayMode = 'cards',
  count = 72,
}) =>
  [...new Array(count)].map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <ProductCardGridItem id={`placeholder-${index}`} key={index} className="group pb-2">
      {/* Image etc */}
      <div
        className={`product-card-image bg-color-grey-light [grid-area:1/2/span_1/span_1 ${displayMode === 'cards' ? 'h-[300px]' : 'h-[450px]'}`}
      />

      {/* brand and name */}
      <div className="bg-color-grey-light mx-2 mt-2 h-[19px] [grid-area:2/2/span_1/span_1]" />
      <div className="bg-color-grey-light mx-2 mt-1 h-[60px] [grid-area:3/2/span_1/span_1]" />

      {/* price */}
      <div
        className="bg-color-grey-light mx-2 mt-1 [grid-area:4/2/span_5/span_1]"
        style={{
          height: `28px`,
        }}
      />

      {/* color buttons, should be always visible */}
      <div className="bg-color-grey-light mx-2 mt-1 h-[30px] [grid-area:9/2/span_1/span_1]" />
      {/* extended description */}
      {displayMode === 'moreInformation' && (
        <div className="product-card-extended-description bg-color-grey-light mx-2 mt-1 h-[50px] [grid-area:10/2/span_1/span_1]" />
      )}
    </ProductCardGridItem>
  ));
